// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__2HRk9","alert":"SettungsInbox_alert__3zyxi"};